module.exports = __webpack_public_path__ + "img/error.1ce2f2c2.png";